import {Component} from '@angular/core';
/**
 * \@title Basic datepicker
 */
export class DatepickerOverviewExample {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'datepicker-overview-example',
  templateUrl: 'datepicker-overview-example.html',
  styleUrls: ['datepicker-overview-example.css'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DatepickerOverviewExample_tsickle_Closure_declarations() {
/** @type {?} */
DatepickerOverviewExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DatepickerOverviewExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
